<template>
  <div class="profile">
    <navbar />

    <b-container>
      <b-row>
        <b-col>
          <h1 class="my-4">My Profile</h1>
        </b-col>
      </b-row>

      <b-form @submit.prevent="onUpdateProfile">
        <b-row>
          <b-col md="12">
            <b-form-group label="I am a">
              <b-form-radio-group
                v-model="userLocal.role"
                id="radio-group-2"
                name="radio-sub-component"
                required
              >
                <b-form-radio value="student">student</b-form-radio>
                <b-form-radio value="parent">parent</b-form-radio>
                <b-form-radio value="educator">educator</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Name:" label-for="name-input">
              <b-form-input
                v-model="userLocal.name"
                id="name-input"
                type="text"
                placeholder="Enter name"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="School:" label-for="school-input">
              <b-form-input
                v-model="userLocal.school"
                id="school-input"
                type="text"
                placeholder="Enter school name"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              v-if="userLocal.role == 'student'"
              label="Grade:"
              label-for="age-input"
            >
              <b-form-select v-model="userLocal.grade" class="mb-3">
                <option value="a">Standard 1</option>
                <option value="a">Standard 2</option>
                <option value="a">Standard 3</option>
                <option value="a">Standard 4</option>
                <option value="a">Standard 5</option>
                <option value="a">Standard 6</option>
                <option value="a">Form 1</option>
                <option value="a">Form 2</option>
                <option value="a">Form 3</option>
                <option value="a">Form 4</option>
                <option value="a">Form 5</option>
                <option value="a">Year 5 (Cambridge)</option>
                <option value="a">Year 6 (Cambridge)</option>
                <option value="a">Year 7 (Cambridge)</option>
                <option value="a">Year 8 (Cambridge)</option>
                <option value="a">Year 9 (Cambridge)</option>
                <option value="a">Year 10 (IGCSE)</option>
                <option value="a">Year 11 (IGCSE)</option>
                <option value="a">Foundation &amp; equivalent</option>
                <option value="a">Degree</option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              v-if="userLocal.role == 'student'"
              label="Age:"
              label-for="age-input"
            >
              <b-form-input
                v-model="userLocal.age"
                id="age-input"
                type="number"
                placeholder="Enter age"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              v-if="userLocal.role == 'educator'"
              label="Position:"
              label-for="age-input"
            >
              <b-form-input
                id="age-input"
                type="text"
                v-model="userLocal.position"
                placeholder="Enter role/position in school"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Email:" label-for="email-input">
              <b-form-input
                id="email-input"
                v-model="userLocal.email"
                type="email"
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mb-4">
          <b-col>
            <b-button variant="primary" type="submit">Update</b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-container>

    <app-footer />
  </div>
</template>

<script>
import { mapState } from "vuex";
import AppFooter from "@/components/AppFooter.vue";
import Navbar from "@/components/Navbar.vue";
import UserServices from "@/services/user-services";

export default {
  name: "Profile",

  components: {
    Navbar,
    AppFooter
  },

  data() {
    return {
      userLocal: {}
    };
  },

  mounted() {
    this.getUserProfile();
  },

  computed: {
    ...mapState(["user"])
  },

  methods: {
    getUserProfile() {
      UserServices.getUserProfile(this.user.uid)
        .then(user => {
          this.userLocal = user;
        })
        .catch(error => {
          alert(error.message);
          console.log(error);
        });
    },

    updateUserProfile() {
      UserServices.updateUserProfile(this.userLocal)
        .then(() => {
          alert("Profile updated!");
        })
        .catch(error => {
          alert(error.message);
        });
    },

    onUpdateProfile() {
      UserServices.updateUserProfile(this.userLocal)
        .then(() => {
          alert("Profile updated!");
        })
        .catch(error => {
          alert(error.message);
        });
    }
  }
};
</script>

<style lang="less" scoped></style>
